export default __webpack_public_path__ + "static/media/bag.9f716565.svg";